import Typography from '@/common/components/base/typography/Typography';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { GetComplaintSummaryQueryResponseType } from '../../queries/getComplaintSummary/getComplaintSummaryQuery.type';

export default function SatisfactionComplaint({
  data,
}: {
  data?: GetComplaintSummaryQueryResponseType;
}) {
  const subjects = data?.subjects ?? [];

  return (
    <Box>
      {subjects.map((subject) => (
        <Flex
          key={subject.id}
          alignItems="center"
          justifyContent="space-between"
          py="10px"
          direction="row"
        >
          <Typography
            color="black"
            textStyle="b1"
            className={css({
              flex: 1,
              textAlign: 'right',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            })}
          >
            {subject.name}
          </Typography>

          <Flex
            alignItems="center"
            gap="4px"
            justifyContent="flex-end"
            className={css({ width: '60px', flexShrink: 0 })}
          >
            <Typography color="black" fontWeight="bold" fontSize={16}>
              {subject.complaint_count} مورد
            </Typography>
          </Flex>
        </Flex>
      ))}
    </Box>
  );
}
